import {
  customerAddNote
} from '../../services/apis'
import {
  hasError,
  isServerResponseError,
} from '../common'

const addNote = async (id, data) => {
  const response = await customerAddNote(id, data)
  return isServerResponseError(response) || hasError(response)
    ? 'failed'
    : 'success'
}

export default addNote